/**
=========================================================
* Course Progress Runner Component
* Reusable progress indicator for course pages
=========================================================
*/

import { useNavigate } from "react-router-dom";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function CourseProgressRunner({ 
  currentStep, 
  totalSteps, 
  title, 
  subtitle, 
  onBack,
  showBackButton = true 
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate("/e-learning");
    }
  };

  return (
    <MDBox 
      p={3} 
      sx={(theme) => ({ 
        borderBottom: `1px solid ${theme.palette.backgroundSbi.default}80` 
      })}
    >
      <MDBox display="flex" alignItems="center" justifyContent="space-between">
        <MDBox>
          <MDTypography 
            variant="h5" 
            fontWeight="medium" 
            color="white"
            sx={(theme) => ({
              background: `linear-gradient(135deg, ${theme.palette.accent.tealLight} 0%, ${theme.palette.accent.cyan} 100%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            })}
          >
            {title} {currentStep}/{totalSteps}
          </MDTypography>
          {subtitle && (
            <MDTypography variant="body2" color="white" opacity={0.7} mt={0.5}>
              {subtitle}
            </MDTypography>
          )}
        </MDBox>
        {showBackButton && (
          <MDButton
            variant="text"
            color="white"
            onClick={handleBack}
            startIcon={<Icon>arrow_back</Icon>}
          >
            Back to E-Learning
          </MDButton>
        )}
      </MDBox>
      {/* Progress Bar */}
      <MDBox display="flex" gap={1} mt={2}>
        {Array.from({ length: totalSteps }, (_, i) => i + 1).map((stepNum) => (
          <MDBox
            key={stepNum}
            sx={(theme) => ({
              height: 8,
              flex: 1,
              borderRadius: 1,
              backgroundColor:
                stepNum <= currentStep
                  ? theme.palette.backgroundSbi.secondary
                  : `${theme.palette.backgroundSbi.secondary}4D`,
              transition: "background-color 0.3s",
            })}
          />
        ))}
      </MDBox>
    </MDBox>
  );
}

export default CourseProgressRunner;
